import React from 'react';

export default () => (
    <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.749981 1.49999H23.25C23.664 1.49999 23.9999 1.16397 23.9999 0.750011C23.9999 0.335995 23.6639 3.05176e-05 23.25 3.05176e-05H0.749981C0.335964 3.05176e-05 0 0.336057 0 0.750011C0 1.16397 0.336026 1.49999 0.749981 1.49999Z" fill="black"/>
<path d="M23.25 5.25006H0.749981C0.335964 5.25006 0 5.58609 0 6.00004C0 6.414 0.336026 6.75002 0.749981 6.75002H23.25C23.664 6.75002 23.9999 6.414 23.9999 6.00004C23.9999 5.58609 23.664 5.25006 23.25 5.25006Z" fill="black"/>
<path d="M15.75 10.5H0.74998C0.335963 10.5 0 10.836 0 11.25C0 11.664 0.336026 12 0.74998 12H15.75C16.164 12 16.4999 11.6639 16.4999 11.25C16.5 10.836 16.164 10.5 15.75 10.5Z" fill="black"/>
</svg>

)